import { render, staticRenderFns } from "./AuctionList.vue?vue&type=template&id=0843e8cc&scoped=true&"
import script from "./AuctionList.vue?vue&type=script&lang=js&"
export * from "./AuctionList.vue?vue&type=script&lang=js&"
import style0 from "./AuctionList.vue?vue&type=style&index=0&id=0843e8cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0843e8cc",
  null
  
)

export default component.exports